import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
//import { DataService } from "../../services/data.service";
import { TranslateService } from "@ngx-translate/core";
import { logbaseService } from "../../services/logbase.service";
import { HttpClient } from "@angular/common/http";
//import { JwtHelper } from "angular2-jwt";
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from '../../services/utils';

const OPERATION_TYPE = "Supplier To Supplier";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
  token: any;
  firstTime: any;
  adminRole: any;
  adminAccess: any;
  loggedInUser: any;
  //jwt = new JwtHelper();
  disableMenu: boolean = false;
  dropdownValues = [];
  selectedItem;
  userDetails;
  loginDetails;
  loginUserDetails;
  displayRoleDropdownFlag;
  userOperationType;
  checkOperationType: boolean = false;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private httpClient: HttpClient,
    private logbaseService: logbaseService,
    private spinner: NgxSpinnerService,
    private authService: AuthService
  ) {
    let userDetails = localStorage.getItem("userDetails");
    this.token = localStorage.getItem('userToken');
    let userDetJson = JSON.parse(userDetails);
    this.loggedInUser = userDetJson.loginId;
    this.adminAccess = userDetJson.userRoleMappings[0].roleId;
    this.adminRole = userDetJson.userRoleMappings[0].roleName;
    this.userDetails = userDetJson;
    this.firstTime = userDetJson.newPassword;
  }

  ngOnInit() {
    if (this.router.url == '/resetPassword') {
      this.disableMenu = true;
    }
    let rowArrayRaw = localStorage.getItem('userRoleArray');
    this.dropdownValues = JSON.parse(rowArrayRaw);

    let url = document.URL;
    if (!url.includes("dashboard"))
      this.displayRoleDropdownFlag = true;
    this.userOperationType = this.userDetails.operationType
    this.checkOperationType =
      this.adminAccess === 4 && this.userOperationType === OPERATION_TYPE
        ? true
        : false;
    //console.log(this.displayRoleDropdownFlag);
  }
  roleChange(event) {
    this.spinner.show();
    //console.log("Load new dash board*****");
    //console.log(event.target.innerHTML);
    var logIdraw = localStorage.getItem('currentUser');
    var loginIdparsed = JSON.parse(logIdraw);
    let loginData = {
      loginId: loginIdparsed,
      userRoleName: event.target.innerHTML
    }
    this.logbaseService.getRoleDetails(loginData).subscribe(result => {
      this.loginDetails = result;
      this.spinner.hide();
      if (this.loginDetails.status.statusCode == 1) {
        this.loginUserDetails = this.loginDetails.response;
        localStorage.setItem('userDetails', JSON.stringify(this.loginDetails.response));
        location.reload();
        
      }
      else if (this.loginDetails.status.statusCode == -1 && this.loginDetails.status.displayMessage == 'AUTHORIZATION FAILED') {
        this.spinner.hide();
        Utils.alertWithMesssgeUpdated("You are not authorized to access..!");
        setTimeout(() => { this.authService.logout(); this.spinner.show() }, 5000);
        return;
      }

    })
  }

  authSignOut() {
    /* this.logbaseService.logoutUser(this.loggedInUser).subscribe(result => { });
     var localpkgId = localStorage.getItem("packageID");
     // this.lockUnlockPackage(localpkgId);
     localStorage.removeItem("currentUser");
     localStorage.removeItem("userDetails");
     localStorage.removeItem('userToken')
     localStorage.removeItem("overAllPackageIDStatus");
     localStorage.removeItem("packageID");
     localStorage.removeItem("tempSupItem");
     localStorage.removeItem("usersData");
     localStorage.removeItem("partsData");
     localStorage.removeItem('cacheUser')
     localStorage.removeItem(this.loggedInUser);
     localStorage.removeItem('todoSuppCode');
     localStorage.removeItem('partStatusSuppCode');
 
     localStorage.removeItem('partStatusLineNo');
     localStorage.removeItem('todoLineNo');
 
     this.router.navigate(["/login"]);*/
    this.authService.logout();
  }

  lockUnlockPackage(routePackageID) {
    let dataToSend = {
      pkgStatus: "DISABLE",
      pkgId: routePackageID
    };
    this.logbaseService.packageLockUnlock(dataToSend).subscribe(result => { });
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    localStorage.setItem("language", language);
  }
}
